// extracted by mini-css-extract-plugin
module.exports = {"page":"_2WtoZ","content":"wWg5_"};